import type { MissionDto } from '@/api/hooks'

/**
 * A mission can only be cancelled while its fleet is still OUTBOUND — past the
 * midpoint the ships are already closer to the destination than to home, so the
 * backend refuses the cancel (`past_midpoint`). Mirrors the server rule exactly
 * (`midpoint = startedAt + (resolvesAt - startedAt) / 2`) so the button only
 * shows when the call would actually succeed. Patrol is never cancellable
 * (onboarding-only, enforced server-side as `patrol_not_cancellable`).
 */
export function isMissionCancellable(mission: MissionDto, now: number = Date.now()): boolean {
  if (mission.status !== 'in_progress') return false
  if (mission.type === 'patrol') return false
  const startedAtMs = new Date(mission.startedAt).getTime()
  const resolvesAtMs = new Date(mission.resolvesAt).getTime()
  const midpoint = startedAtMs + (resolvesAtMs - startedAtMs) / 2
  return now < midpoint
}
